let accessTokenGetter: (() => string | undefined) | undefined;

export const setAccessTokenGetter = (
  getter?: () => string | undefined
): void => {
  accessTokenGetter = getter;
};

export const getAccessToken = (): string | undefined => accessTokenGetter?.();
